import {cn} from '@sollapay/ui';

import {PageErrorState} from '@/components';

import type {ComponentProps} from 'react';

export {PageContent} from '@sollapay/ui';

interface PageLayoutProps extends ComponentProps<'main'> {
  /** Truthy to show the error state. Pass the query's raw `error` (not just `isError`) so `PageErrorState` can tailor the message per error code. */
  error?: unknown;
  refetch?: () => void;
}

export function PageLayout({className, error, refetch, children, ...props}: PageLayoutProps) {
  return (
    <main
      className={cn('flex flex-col flex-1 min-h-0 animate-in fade-in duration-300', className)}
      {...props}
    >
      {error ? <PageErrorState error={error} refetch={refetch} /> : children}
    </main>
  );
}
